
        export const version = '6.2.1';
        export const buildTimestampIso = '2023-03-08T07:27:28.291Z';
        export const versionCheck = '6.2.1,2023-03-08T07:27:27.688Z';
        export const curEnv = 'preprod';
        export const hash = '0e7031602';
        export const commit = "[spa] 1917: Update copyright name";
        export const commitTimestampIso = '2022-08-22T10:45:03-07:00';
        